import React, { Component } from 'react';

class IconInfo extends Component {
    render() {
        return (
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>Info</title>
            <g id="info" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <polygon id="Path" fill="#000000" fillRule="nonzero" points="10.726 9.412 13.274 9.412 13.274 20.358 10.726 20.358"/>
              <path d="M10.362,4.888 C10.362,3.952 11.064,3.25 12,3.25 C12.936,3.25 13.638,3.952 13.638,4.888 C13.638,5.824 12.936,6.526 12,6.526 C11.064,6.526 10.362,5.824 10.362,4.888 Z" id="Path" fill="#000000" fillRule="nonzero"/>
            </g>
          </svg>
        )
    }
}

export default IconInfo;